import { render } from "./FundDetail.vue?vue&type=template&id=5a7dd897&scoped=true"
import script from "./FundDetail.vue?vue&type=script&lang=js"
export * from "./FundDetail.vue?vue&type=script&lang=js"

import "./FundDetail.vue?vue&type=style&index=0&id=5a7dd897&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7dd897"]])

export default __exports__